// transfers
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import WebbDividerSmall from "../webb/webb-divider-sm";
import WebbDividerMedium from "../webb/webb-divider-md";
import WebbModuleInfo from "../webb/webb-module-info";
import FormNeeded from "../webb/form-needed";
import WebbSpinner from "../webb/webb-spinner-sm";
import ListNoData from "../webb/list-nodata";

import { UserForm } from "../../services/srvc-utilities";
import { GetLocalUser, GetLocalBusiness } from "../../services/srvc-auth-user";
import { GetUserEventsList, GetEventsCount } from "../../services/srvc-events-realm";


export default function TokensListModule() {

  const asset = UserForm() === 'in' ? GetLocalUser() : GetLocalBusiness();
  const [loading, setLoading] = useState(true);

  const [item, setItems] = useState(10); // rows per page
  const [rows, setRows] = useState(0); // total rows
  const [cntr, setCounter] = useState(1); // current page counter
  const [live, setLive] = useState(false); // live stream

  const [data, setData] = useState([]);

  useEffect( () => {
    if (asset){
      const fetchData = async() => {
        
        setRows ((await GetEventsCount()).data)
        
      }
      fetchData()
    } else {}
  },[asset.usid]);

  useEffect( () => {
    if (asset){
      const fetchData = async() => {
        
        setLoading(true);
        
        setData ((await GetUserEventsList(({
          data: {usid: asset.usid, item: item, cntr: cntr},
          user: asset.usid
        }))).data)
        
        setLoading(false);
      }
      fetchData()
    } else {}
  },[asset.usid, cntr, item]);


  const handleItem = items => {
    setItems(items)
  }


  const handleCounter = counter => {
    setCounter(counter)
  }


  if (loading){ return ( <> <div className="text-center"><WebbSpinner /></div> </> ) }
  if (!data || data.length === 0) { return ( <> <ListNoData/> </> ) }

  return (
  <>
    {console.log(data)}
    <div className="">
  
    {data && data.map((item, i) => (
        <Link to = {`/${UserForm()}/tokens/view/${item.enid}`} key={i}>
          <div className="d-flex bg-wite text-dark rounded-wd mb-3 hilite" >
          {/* options */}
          <div className='col-2' style={{width:'128px', height:'128px'}}>
            <img src={item.link} className="img-fluid rounded-wd" width={'128'} alt="..."></img>
          </div>

          <div className='p-2 ps-3'>
            <p className='fw-bold m-0 text-color-main text-sm'>{item.name}</p>
            <p className='small mb-2 text-md'>{item.memo}</p>
            <p className='small fw-bold mb-2 text-md'>{item.form}</p>
          </div>

          </div>
        
        </Link>

      ))}

    </div>

  </>
  )
}